






































import { Component, Ref } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import { ModalFooter } from '@/components/molecules/ModalFooter'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import { Alert, AlertMessage, ErrorMessage, reserveApi } from '@/api'
import { alertStore, modalErrorStore } from '@/utils/store-accessor'
import { AlertFactory } from '@/factory'
import { AlertCodeALC00007, CommandType, ReceiptPrintName } from '@/types'
import { InputDatePicker } from '@/components/molecules/InputDatePicker'
import { setErrorMessage } from '@/utils/error'
import { ReserveReceipt } from '@/api/models/reserve/ReserveReceipt'

export interface ModalReserveExpirationDateBulkEditInterface {
  userId: string
  data: {
    reserveId: number
    collectionId: number
    revision: number
  }[]
  onUpdated: () => void
}

interface ModalReserveExpirationDateBulkEditItem {
  dialog: boolean
  userId: string
  data: {
    reserveId: number
    collectionId: number
    revision: number
  }[]
  reserveExpiration: {
    input: string
    errorMessage: string
  }
  isReceiptPrintReserve: {
    input: boolean
    errorMessage: string
  }
  onUpdated: () => void
}

const defaultModalReserveExpirationDateBulkEditItem = (): ModalReserveExpirationDateBulkEditItem => ({
  dialog: false,
  userId: '',
  data: [],
  reserveExpiration: {
    input: '',
    errorMessage: ''
  },
  isReceiptPrintReserve: {
    input: false,
    errorMessage: ''
  },
  onUpdated: () => {}
})

@Component({
  components: {
    InputDatePicker,
    ModalFooter
  }
})
export default class ModalReserveExpirationDateBulkEdit extends ModalComponentBaseVue {
  @Ref()
  reserveExpirationDatePicker!: InputDatePicker

  modalItem: ModalReserveExpirationDateBulkEditItem = defaultModalReserveExpirationDateBulkEditItem()

  ok(): void {
    const alert: Alert = AlertFactory.create(
      AlertCodeALC00007,
      '受取期限日',
      '更新'
    )
    alertStore.setItem(alert)
    this.$modalAlert.open({
      onOkClick: async () => {
        this.$eventBus.emit(PAGE_LOADING_START)

        try {
          await this.bulkUpdateToReserveExpirationDate()
          if (this.modalItem.isReceiptPrintReserve.input) {
            const responses: ReserveReceipt[] = await this.getReceiptReserveInfos()
            if (responses.length > 0) {
              this.printReserveReceipt(responses) // 通信に失敗したら何もしない予定
            }
          }

          this.modalItem.onUpdated()
          this.close()
        } catch (error) {
          this.focus()
        } finally {
          this.$eventBus.emit(PAGE_LOADING_END)
        }
      },
      onCancelClick: this.focus
    })
  }

  open(params: ModalReserveExpirationDateBulkEditInterface): void {
    this.modalItem = Object.assign(
      defaultModalReserveExpirationDateBulkEditItem(),
      {
        dialog: true,
        userId: params.userId,
        data: params.data,
        onUpdated: params.onUpdated
      }
    )
    this.focus()
  }

  close(): void {
    this.modalItem = defaultModalReserveExpirationDateBulkEditItem()
  }

  focus(): void {
    setTimeout(() =>
      this.$nextTick(
        this.reserveExpirationDatePicker.textField.atomTextField.focus
      )
    )
  }

  existsErrorMessage(errorMessage: string): boolean {
    return errorMessage !== ''
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  async bulkUpdateToReserveExpirationDate(): Promise<void> {
    try {
      await reserveApi.updateBulkReserveExpiration({
        reserves: this.modalItem.data.map(value => {
          return {
            id: value.reserveId,
            revision: value.revision
          }
        }),
        reserveExpiration: this.modalItem.reserveExpiration.input
      })
    } catch (error) {
      this.$eventBus.emit(PAGE_LOADING_END)

      if (error instanceof AlertMessage) {
        setErrorMessage(error.alerts, this.modalItem)
        alertStore.setItems(error.alerts)
        await new Promise((resolve, reject) => {
          this.$modalAlert.open({
            onOkClick: () => reject(new Error())
          })
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        await new Promise((resolve, reject) => {
          this.$modalError.open({
            onOkClick: () => reject(new Error())
          })
        })
      } else {
        console.error(error)
      }

      throw error
    }
  }

  // ここはエラーを起こしてもそのまま使用する
  async getReceiptReserveInfos(): Promise<ReserveReceipt[]> {
    try {
      return await reserveApi.getReserveReceipt({
        collections: this.modalItem.data.map(value => {
          return {
            id: value.collectionId,
            reservedUserId: this.modalItem.userId
          }
        })
      })
    } catch (error) {
      this.$eventBus.emit(PAGE_LOADING_END)

      if (error instanceof AlertMessage) {
        setErrorMessage(error.alerts, this.modalItem)
        alertStore.setItems(error.alerts)
        await new Promise(resolve => {
          this.$modalAlert.open({
            onOkClick: resolve
          })
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        await new Promise(resolve => {
          this.$modalError.open({
            onOkClick: resolve
          })
        })
      } else {
        console.error(error)
      }

      return []
    }
  }

  printReserveReceipt(infos: ReserveReceipt[]): void {
    infos.forEach(info => {
      if (info.receiptInfoReserve !== undefined) {
        this.$webSocket.sendReceiptPrintMessage({
          command: CommandType.ReceiptPrintReserve,
          name: ReceiptPrintName.ReceiptPrintReserve,
          data: info.receiptInfoReserve,
          subject: `利用者番号：${info.receiptInfoReserve.user_id}`
        })
      }
      if (info.receiptInfoReserveForwarding !== undefined) {
        this.$webSocket.sendReceiptPrintMessage({
          command: CommandType.ReceiptPrintReserveForwarding,
          name: ReceiptPrintName.ReceiptPrintReserveForwarding,
          data: info.receiptInfoReserveForwarding,
          subject: `資料番号：${info.receiptInfoReserveForwarding.collection_no}`
        })
      }
    })
  }
}
